import { render, staticRenderFns } from "./threeTwoPlatformsManagement.vue?vue&type=template&id=19b198c8&scoped=true"
import script from "./threeTwoPlatformsManagement.vue?vue&type=script&lang=js"
export * from "./threeTwoPlatformsManagement.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/popUp.scss?vue&type=style&index=0&id=19b198c8&prod&lang=scss&scoped=true&external"
import style1 from "@/assets/css/tableList.scss?vue&type=style&index=1&id=19b198c8&prod&lang=scss&scoped=true&external"
import style2 from "./threeTwoPlatformsManagement.vue?vue&type=style&index=2&id=19b198c8&prod&lang=scss&scoped=true"
import style3 from "./threeTwoPlatformsManagement.vue?vue&type=style&index=3&id=19b198c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b198c8",
  null
  
)

export default component.exports